export default __webpack_public_path__ + "static/media/two.8849e379.jpeg";